import { useGetResourceFieldTypesSuspense } from "@/orval/gen"
import { ResourceTypeCategory } from "../../../../@client/Theasoft_DataClasses_Dispo"
export default function useGetResourceObjectFieldTypes(
  category: ResourceTypeCategory
) {
  return useGetResourceFieldTypesSuspense({
    fieldVisibility: "ResourceObject",
    category,
  })
}
